import { render, staticRenderFns } from "./StandartReducedPrice.vue?vue&type=template&id=6e21e129&scoped=true"
import script from "./StandartReducedPrice.vue?vue&type=script&lang=js"
export * from "./StandartReducedPrice.vue?vue&type=script&lang=js"
import style0 from "./StandartReducedPrice.vue?vue&type=style&index=0&id=6e21e129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21e129",
  null
  
)

export default component.exports